<template>
    <div class="vizy-blocks">
        <template v-if="pending">
            <div
                v-for="i in [1,2,3,4,5,6,7,8,9,10]"
                :key="i"
                class="vizy-blocks__block"
                data-type="paragraph"
            >
                <p>
                    <Skeletor width="100%" /><br>
                    <Skeletor width="100%" /><br>
                    <Skeletor width="80%" /><br>
                    <Skeletor width="90%" /><br>
                    <Skeletor width="40%" /><br>
                </p>
            </div>
        </template>
        <div
            v-for="(node, index) in nodes"
            v-else
            :key="index"
            class="vizy-blocks__block"
            :data-type="node.blockTypeHandle || node.type"
        >
            <slot
                :name="node.blockTypeHandle || node.type"
                v-bind="node"
            >
                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-html="node.html || `Failed to render block of type ${node.blockTypeHandle || node.type}`"
                />
                <!-- eslint-enable vue/no-v-html -->
            </slot>
        </div>
    </div>
</template>

<script setup>


defineProps({
    pending: {
        type: Boolean,
        required: false,
        default: false
    },
    nodes: {
        type: Array,
        required: false,
        default: () => []
    },
});
</script>

<style lang="less">
.vizy-blocks {
    .base-grid();
    grid-template-rows: auto;
    row-gap: var(--spacing-sm);
    padding-top: var(--spacing-sm);
}

.vizy-blocks__block {
    grid-column: first/right-side-gutter;

    a {
        text-decoration: none;
    }

    .text-center {
        text-align: center;
    }

    &[data-type='imageRepeater'],
    &[data-type='imageSlider'] {
        /* Grid reset  */
        grid-column: 1/-1;
        margin: var(--spacing-xl) 0;
    }

    &[data-type='faq'] {
        margin: var(--spacing-xl) 0;

        h2 {
            .typography-h3();
            margin-bottom: var(--spacing-lg);
        }
    }

    &[data-type='videoEmbed'],
    &[data-type='wideImage'],
    &[data-type='illustrationGrid'],
    &[data-type='map']{
        grid-column: first/right-side-gutter;
    }

    &[data-type='wideImage'],
    &[data-type='illustrationGrid'],
    &[data-type='quote'],
    &[data-type='videoEmbed'] {
        margin: var(--spacing-sm) 0;
    }

    &[data-type='wideImage']:last-child,
    &[data-type='videoEmbed']:last-child {
        margin-bottom: 0;
    }

    &[data-type='enquiryForm'] {
        margin: var(--spacing-sm) 0;
        grid-column: first/right-side-gutter;

        @media @q-lg-min {
            grid-column: left-gutter/third;
        }
    }

    &:last-child {
        &[data-type='quote'],
        &[data-type='imageRepeater'],
        &[data-type='paragraph'],
        &[data-type='imageSlider'] {
            margin-bottom: var(--spacing-sm);
        }
    }

    @media @q-md-min {
        grid-column: second/third;

        &[data-type]:first-child {
            margin-top: var(--spacing-xl);
        }

        &[data-type='faq'] {
            grid-column: second/third;
            margin: var(--spacing-xl) 0;

            h2 {
                margin-bottom: var(--spacing-sm);
            }

            .base-accordion__button, .base-accordion__content p {
                font-size: var(--font-size-xl);
            }
        }

        &[data-type='wideImage'] {
            margin: var(--spacing-2xl) 0;
        }

        &[data-type='quote'],
        &[data-type='videoEmbed'],
        &[data-type='imageRepeater'],
        &[data-type='imageSlider'] {
            margin: var(--spacing-3xl) 0;
        }

        &[data-type='quote'] {
            grid-column: second/right-side-gutter;
        }

        &:last-child {
            &[data-type='quote'],
            &[data-type='imageRepeater'],
            &[data-type='paragraph'],
            &[data-type='imageSlider'] {
                margin-bottom: var(--spacing-xl);
            }
        }

        &[data-type='bulletList'] ul {
            .list-unordered();
        }

        &[data-type='orderedList'] ol {
            .list-ordered();
        }
    }
}
</style>
